import React from 'react';

import './terms-and-conditions.scss';

export const TermsAndConditions = () => {
  return (
    <div className="terms-and-conditions">
      <h1 className="terms-and-conditions__title">Terms & Conditions</h1>
      <p className="terms-and-conditions__text">Effective Date: 24 January 2026</p>
      <h2 className="terms-and-conditions__subtitle">Orders & Accounts</h2>
      <p className="terms-and-conditions__text">
        Users may create accounts or checkout as guests. Orders are processed via PayFast.
      </p>
      <h2 className="terms-and-conditions__subtitle">Payment</h2>
      <p className="terms-and-conditions__text">
        Payments are secure and tokenized. Prices and taxes are displayed at checkout.
      </p>
      <h2 className="terms-and-conditions__subtitle">Delivery</h2>
      <p className="terms-and-conditions__text">
        Deliveries are made via our own drivers. Delivery times are estimates.
      </p>
      <h2 className="terms-and-conditions__subtitle">Refunds & Returns</h2>
      <p className="terms-and-conditions__text">
        Refunds are available for defective or incorrect orders. Contact info@instant-meals.co.za to
        initiate.
      </p>
      <h2 className="terms-and-conditions__subtitle">User Responsibilities</h2>
      <p className="terms-and-conditions__text">
        Provide accurate information and notify us of issues with orders.
      </p>
      <h2 className="terms-and-conditions__subtitle">Limitation of Liability</h2>
      <p className="terms-and-conditions__text">
        We are not liable for indirect, incidental, or consequential damages. Meals provided as-is;
        see Disclaimer.
      </p>
      <h2 className="terms-and-conditions__subtitle">Governing Law</h2>
      <p className="terms-and-conditions__text">
        Governed by South African law. Disputes resolved via arbitration or SA courts.
      </p>
    </div>
  );
};
